import { collection } from "firebase/firestore";
import { db } from "./config.js";

export const templateRef = collection(db, "templates");
export const templateFeedbackRef = collection(db, "projects-feedback");
export const projectsRef = collection(db, "projects");
export const usersRef = collection(db, "users");